import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Box } from '@mui/material';
import { Lead, User } from '../types';
import { AgentUserRS } from '../utils/api';
import LeadCard from './MinimalLeadCard';

interface SortableLeadCardProps {
  lead: Lead;
  onViewDetails: (lead: Lead) => void;
  users: User[];
  agentUsers?: AgentUserRS[];
  onAssign?: (lead: Lead) => void;
  onTransfer?: (lead: Lead) => void;
  isMobile?: boolean;
}

const SortableLeadCard: React.FC<SortableLeadCardProps> = ({
  lead,
  onViewDetails,
  users,
  agentUsers = [],
  onAssign,
  onTransfer,
  isMobile = false,
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: lead._id.$oid,
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition: transition || 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
    opacity: isDragging ? 0.9 : 1,
    zIndex: isDragging ? 999 : 'auto',
  };

  return (
    <Box
      ref={setNodeRef}
      sx={{
        ...style,
        cursor: isDragging ? 'grabbing' : 'grab',
        transform: style.transform,
        '&:active': {
          cursor: 'grabbing',
        },
        transition: style.transition,
        touchAction: 'none', // Prevents scrolling on touch devices while dragging
        // Melhorar a aparência durante o drag
        ...(isDragging && {
          filter: 'drop-shadow(0 8px 25px rgba(0,0,0,0.15))',
          '& > *': {
            transform: 'rotate(2deg) scale(1.02)',
          },
        }),
      }}
      {...attributes}
      {...listeners}
    >
      <LeadCard
        lead={lead}
        onViewDetails={onViewDetails}
        users={users}
        agentUsers={agentUsers}
        isDragging={isDragging}
        onAssign={onAssign}
        onTransfer={onTransfer}
        isMobile={isMobile}
      />
    </Box>
  );
};

export default SortableLeadCard;